import LevelsTable from './LevelsTable';

export default LevelsTable;
